import api from './api';

export interface LoginData {
  username: string;
  password: string;
}

export interface User {
  id: number;
  nome: string;
  email: string;
  perfil: string;
  ativo?: boolean;
  acesso_todos?: boolean;
}

export interface AuthResponse {
  access_token: string;
  token_type: string;
  user: User;
}

export interface RegisterData {
  nome_completo?: string;
  cpf: string;
  email: string;
  senha: string;
}

export interface PublicAuthConfig {
  allow_public_register: boolean;
  registration_mode: 'open' | 'claim_only';
}

export const authService = {
  async login(data: LoginData): Promise<AuthResponse> {
    const params = new URLSearchParams();
    params.append('username', data.username);
    params.append('password', data.password);

    const response = await api.post<AuthResponse>('/api/auth/login', params.toString(), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });

    if (response.data.access_token) {
      localStorage.setItem('token', response.data.access_token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
    }

    return response.data;
  },

  async register(data: RegisterData): Promise<AuthResponse> {
    const response = await api.post<AuthResponse>('/api/auth/register', data);

    if (response.data.access_token) {
      localStorage.setItem('token', response.data.access_token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
    }

    return response.data;
  },

  logout(): void {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  },

  getToken(): string | null {
    return localStorage.getItem('token');
  },

  getUser(): User | null {
    const userStr = localStorage.getItem('user');
    return userStr ? JSON.parse(userStr) : null;
  },

  isAuthenticated(): boolean {
    return !!this.getToken();
  },

  async getCurrentUser(): Promise<User> {
    const response = await api.get<User>('/api/auth/me');
    return response.data;
  },

  async requestPasswordReset(email: string): Promise<void> {
    await api.post('/api/auth/password-reset/request', { email });
  },

  async confirmPasswordReset(token: string, senha: string): Promise<void> {
    await api.post('/api/auth/password-reset/confirm', { token, senha });
  },

  async getPublicConfig(): Promise<PublicAuthConfig> {
    const response = await api.get<PublicAuthConfig>('/api/auth/public-config');
    return response.data;
  },
};

